import { Box, Pagination } from '@mui/material';
import PropTypes from 'prop-types';
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import { useGetReviewsQuery } from '../features/api/rest/apiReviewsSlice';
import ProductOrganizationReviewCard from './ProductOrganizationReviewCard';
import Error from './Error';
import Spinner from './Spinner';

function ProductOrganizationReviews({ ean, searchParamsName }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  searchParamsName = searchParamsName ? searchParamsName + '_' : '';
  const reviewsForPage = parseInt(searchParams.get(searchParamsName + 'psize'), 10) || 10;
  const reviewPage = parseInt(searchParams.get(searchParamsName + 'page'), 10) || 1;
  const ordering = searchParams.get(searchParamsName + 'ordering') || '-id';

  const { reviews, reviewsCount, isLoading, isFetching, isError } = useGetReviewsQuery(
    { ean, mine: false, ordering: ordering, page: reviewPage, psize: reviewsForPage },
    {
      selectFromResult: (result) => ({
        ...result,
        reviews: result.data?.results,
        reviewsCount: result.data?.count || 0,
      }),
    }
  );

  const handlePageChange = (page) => {
    searchParams.set(searchParamsName + 'page', page);
    navigate(`${pathname}?${searchParams.toString()}`);
  };

  if (isLoading || isFetching) return <Spinner />;

  if (isError) return <Error />;

  const pagination = <Pagination sx={{ my: 2 }} count={Math.ceil(reviewsCount / reviewsForPage)} page={reviewPage} onChange={(event, newPage) => handlePageChange(newPage)} />;

  return (
    <Box>
      {pagination}
      {reviews &&
        reviews.map((review, index) => {
          return (
            <ProductOrganizationReviewCard
              key={review.id}
              ean={ean}
              id={review.id}
              date={review.created}
              title={review.title}
              description={review.description}
              rating={review.rating}
              owner={review.owner}
              totScore={review.tot_score}
              numVotes={review.num_votes}
            />
          );
        })}
      {pagination}
    </Box>
  );
}

ProductOrganizationReviews.propTypes = {
  ean: PropTypes.string.isRequired,
};

export default ProductOrganizationReviews;
